<div class="column-container align-center full-width">
  @for (item of ratings(); track item.skuId) {
    @if (productMetas()[item.productId] | linkToUrl: undefined: newWindow(): item.skuId; as url) {
      <app-universal-link [url]="allowClick() ? url[0] : ''"
                          [meta]="productMetas()[item.productId]"
                          [openNewWindow]="url[1]"
                          [content]="content"
                          (linkClicked)="openProduct(item.skuId)"/>
      <ng-template #content>
        <div class="row-container item"
             [class.auto-pointer]="!allowClick()"
             [style.padding-top.px]="itemVerticalPadding()"
             [style.padding-bottom.px]="itemVerticalPadding()"
             [style.padding-left.px]="horizontalPadding()"
             [style.padding-right.px]="horizontalPadding()"
             [style.width]="itemWidthCss()">
          <div class="row-container space-between flex-grow">
            <div [style.width.px]="imageSize()"
                 [style.height.px]="imageSize()">
              @if (skuInfos()[item.skuId]; as sku) {
                @if (sku.image; as img) {
                  <app-image-loading [src]="img"
                                     [alt]="item.content"
                                     [clickable]="allowClick()"
                                     [priority]="true"
                                     [ssrSuffix]="ssrImageSuffix"
                                     [targetWidth]="imageSize()"
                                     [targetHeight]="imageSize()"/>
                }
              }
            </div>
            <div class="column-container space-between flex-grow"
                 [style.margin-left.px]="horizontalGap()">
              <div class="hint-text order-id"><span i18n>訂單後四碼：</span>{{item.orderId | lastOrderId: orderDisplayDigits}}</div>
              <div class="flex-grow comment"
                   [style.margin-top.px]="itemGap()"
                   [style.width]="ratingContainerWidth()"
                   [innerHTML]="item.content | linkify | newLineToHtml | safeHTML"></div>
              <div class="row-container space-between flex-grow max-hint"
                   [style.margin-top.px]="itemGap()">
                @if (skuInfos()[item.skuId]; as info) {
                  <div class="hint-text">
                    @if (showName() && productMetas()[item.productId]; as meta) {
                      <span>{{meta.name}}&nbsp;</span>
                    }
                    {{info.color}} - {{info.size}}
                  </div>
                }
                <div class="hint-text">{{item.createTime | timestampDisplay: true}}</div>
              </div>
              @if (item.reply) {
                <div class="column-container space-between flex-grow reply-padding-top"
                     [style.margin-top.px]="itemGap()">
                  <div class="row-container align-center"
                       [style.margin-top.px]="itemGap()">
                    <app-image-loading [src]="'assets/icon_logo.svg'"
                                       [alt]="item.reply"
                                       [clickable]="allowClick()"
                                       [targetWidth]="24"
                                       [targetHeight]="24"/>
                    <div class="cs-name">客服回覆</div>
                  </div>
                  <div class="flex-grow comment"
                       [style.margin-top.px]="itemGap()"
                       [style.width]="ratingContainerWidth()"
                       [innerHTML]="item.reply | linkify | newLineToHtml | safeHTML"></div>
                  <div class="row-container flex-end flex-grow max-hint">
                    <div class="hint-text">{{item.replyTime | timestampDisplay}}</div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </ng-template>
    }
  }
</div>
